<template>
  <div>
    <h2>НАСТРОЙКИ</h2>
    <back></back>
    <div class="wh-block">
      <div class="anketa">
        <ul class="uk-grid-match" uk-grid v-if="item">
          <li class="uk-width-1-2@s">
            <div class="anketa__form podpiska">

              <div class="podpiska__end">
                <div class="podpiska__active" v-if="activeSubscribe">
                  Подписка активна и действует до {{ to_date }}
                  <!--<a class="podpiska__button" href="#" @click="onExtendSubscribe">Продлить подписку</a>-->
                </div>
                <div class="podpiska__finish" v-else>
                  <p><strong>ПОДПИСКА ЗАКОНЧИЛАСЬ!</strong></p>
                  <p v-if="user.balance >= subscribe_price">
                    <a class="podpiska__button" href="#" @click="onExtendSubscribe">Продлить подписку</a>
                  </p>
                  <p v-else>
                    На вашем счету недостаточно средств. Пополните баланс чтобы продлить подписку. Необходимая сумма для продления: {{ subscribe_price }} руб.
                  </p>
                </div>
                <!--Если подписка закончилась, то здесь красным выводим, что  ПРОДЛИТЕ!-->
              </div>

              <label>
                <span>Ваш баланс</span>
                <strong>{{ user.balance }} руб</strong>
                <div class="podpiska__fwrap">
                  <input type="text" v-model="sum" placeholder="Введите сумму" class="uk-input">
                  <button class="podpiska__button" href="#" @click="addMoney">+ Пополнить баланс</button>
                </div>
              </label>

              <label>
                <span>Дополнительные ученики</span>
                <p>В стандартном тарифном плане доступно
                  <strong>5</strong> учеников. Вы можете добавить дополнительных учеников за
                  <strong>250 руб в месяц</strong></p>
                <p>Дополнительных учеников добавлено: <strong>{{ o_params.addition_students }}</strong></p>

                <div class="podpiska__fwrap podpiska__fwrap--col">
                  <div class="podpiska__qnt">
                    <a href="#" @click.prevent="addQnt('-')" class="podpiska__sgn">-</a>
                    <input type="text" v-model="dop_qnt" readonly>
                    <a href="#" @click.prevent="addQnt('+')" class="podpiska__sgn">+</a>
                  </div>
                  <div class="podpiska__message" v-html="dop_message"></div>
                  <button class="podpiska__button" v-if="type" @click="applyChanges">+ Изменить кол-во доп учеников</button>
                </div>
              </label>
            </div>
          </li>
          <li class="uk-width-1-2@s">
            <div>
              <div class="anketa__form">
                <label><span>Имя</span><input v-model="item.name" class="uk-input" type="text" placeholder="Имя"></label>
                <label><span>Email (логин)</span><input v-model="item.email" class="uk-input" type="text" placeholder="Email"></label>
                <!-- <label><span>Дата рождения</span>
                   &lt;!&ndash;<input v-model="item.property.birth_date" class="uk-input" type="text" placeholder="Дата рождения">&ndash;&gt;
                   <input type='text' class="datepicker-here uk-input" readonly :value="birth_date" name="birth_date" placeholder="Дата рождения" data-date-format="dd-mm-yyyy" autocomplete="new-password" />
                 </label>-->
                <label v-if="item.property"><span>Город</span><input class="uk-input" v-model="item.property.city" type="text" placeholder="Город"></label>
              </div>
              <div class="anketa__button">
                <button class="uk-button uk-button-primary" @click="updateUser">Обновить данные</button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert";
import axios from 'axios'
import moment from "moment";

export default {
  name: "student_anketa",
  data() {
    return {
      birth_date: '',
      item: '',
      sum: '',
      dop_qnt: '',
      dop_message: '',
      type: '',
      need_qnt: 0,
      dop_price: '',
      active_students: ''
    }
  },
  props: {},
  watch: {
    'user': function (){
      this.setItem();
      this.checkActiveStudents();
    }
  },
  inject: ['http'],
  computed: {
    user() {
      return this.$store.state.user;
    },
    o_params() {
      return this.user.property.outside_trainer;
    },
    activeSubscribe() {
      let params = this.user.property.outside_trainer;
      let active_to = params.active_to.date;
      return moment().isBefore(active_to);
    },
    to_date() {
      let params = this.user.property.outside_trainer;
      return moment(params.active_to.date).format('D-M-Y H:mm');
    },
    prices() {
      return this.$store.state.prices;
    },
    subscribe_price() {
      let params = this.user.property.outside_trainer;
      let price = this.prices.subscribe;
      let add_students = params.addition_students;
      return price + (add_students * this.prices.per_student);
    }
  },
  methods: {
    async onExtendSubscribe() {
      let data = {
        'user_id': this.user.id,
        'subscribe_price': this.subscribe_price
      }
      //console.log(data);
      // axios.post(window.location.href, data, {
      //   headers: {
      //     'X-OCTOBER-REQUEST-HANDLER': 'onExtendSubscribe',
      //     'X-Requested-With': 'XMLHttpRequest'
      //   }
      // })
      let result = await this.http.post('onExtendSubscribe', data).then((res) => {
        console.log(res);
        if (res.data.message) swal(res.data.message, "", "success");
        if (res.data.user) {
          this.$store.commit('setUser', res.data.user);
        }
      });
    },
    async addMoney() {
      if (!this.sum) {
        swal('Укажите сумму', "", "warning");
      } else {
        let data = {
          'user_id': this.user.id,
          'sum': this.sum,
          'name': this.user.name
        }

        // axios.post(window.location.href, data, {
        //   headers: {
        //     'X-OCTOBER-REQUEST-HANDLER': 'onAddMoney',
        //     'X-Requested-With': 'XMLHttpRequest'
        //   }
        // })
        let result = await this.http.post('onAddMoney', data).then(function (res) {
          console.log(res);
          if (res.data.formUrl) {
            window.location.href = res.data.formUrl;
          }
        });
      }
    },
    async updateUser() {
      let data = {
        user: this.item
      }
      // axios.post(window.location.href, { user: this.item }, {
      //   headers: {
      //     'X-OCTOBER-REQUEST-HANDLER': 'onUpdateUserByTeacher',
      //     'X-Requested-With': 'XMLHttpRequest'
      //   }
      // })
      let result = await this.http.post('onUpdateUserByTeacher', data).then(function (res) {
        console.log(res);
        swal('Анкета отредактирована', "", "success");
      }).catch(function (err) {
        if (err.response) {
          console.log(err.response);
          if (err.response.data.X_OCTOBER_ERROR_MESSAGE) {
            swal(err.response.data.X_OCTOBER_ERROR_MESSAGE, "", "error");
          }
        } else if (err.request) {
          console.log('// client never received a response, or request never left');
        } else {
          console.log('Что-то другое');
          // anything else
        }
      });
    },
    reDate(date) {
      if (date) {
        return moment(date, 'DD-MM-YYYY').format('DD-MM-YYYY');
      }
    },
    setItem() {
      if (this.user) {
        this.item = this.user;
        if (!this.item.property) this.item.property = {};
        if (this.item.property && this.item.property.birth_date) {
          this.birth_date = this.reDate(this.item.property.birth_date);
        }
        this.dop_qnt = this.o_params.addition_students;
      }
    },
    addQnt(sign) {
      if (sign === '-' && this.dop_qnt > 0) {
        this.dop_qnt--;
      } else if (sign === "+") {
        this.dop_qnt++;
      }
      this.changeStudentsQnt();
    },
    /** Функции изменения количества учеников */
    async checkActiveStudents(){
      if(this.user){
        let data = {
          'user_id': this.user.id
        }
        // axios.post(window.location.href, data, {
        //   headers: {
        //     'X-OCTOBER-REQUEST-HANDLER': 'onCheckActiveStudents',
        //     'X-Requested-With': 'XMLHttpRequest'
        //   }
        // })
        let result = await this.http.post('onCheckActiveStudents', data).then((res) => {
          //console.log(res);
          this.active_students = res.data.result;
        });
      }
    },
    clearDops(){
      this.dop_message = '';
      this.need_qnt = 0;
      this.type = '';
    },
    applyChanges() {
      let type = this.type;
      let qnt = this.need_qnt;
      let balance = this.user.balance;
      if (type === 'add') {
        let price = this.dop_price;
        if (balance > price) {
          let data = {
            'price': price,
            'user_id': this.user.id,
            'qnt': qnt,
          }
          this.onSuccessAddDopStudents(data);

        } else {
          swal('Недостаточно средств', `Для совершения операции требуется ${price} рублей. Пополните счет на ${price - balance} рублей, чтобы совершить операцию`, 'warning');
        }

      } else if (type === 'remove') {
        let data = {
          'user_id': this.user.id,
          'qnt': qnt,
        }
        this.onSuccessRemoveDopStudents(data);
      }
    },
    async onSuccessAddDopStudents(data) {
      // axios.post(window.location.href, data, {
      //   headers: {
      //     'X-OCTOBER-REQUEST-HANDLER': 'onAddDopStudent',
      //     'X-Requested-With': 'XMLHttpRequest'
      //   }
      // })
      let result = await this.http.post('onAddDopStudent', data).then((res) => {
        //console.log(res);
        swal(res.data.message, '', 'success');
        this.$store.commit('setUser', res.data.user);
        this.clearDops();
        this.checkActiveStudents();
      });
    },
    async onSuccessRemoveDopStudents(data){
      // axios.post(window.location.href, data, {
      //   headers: {
      //     'X-OCTOBER-REQUEST-HANDLER': 'onRemoveDopStudent',
      //     'X-Requested-With': 'XMLHttpRequest'
      //   }
      // })
      let result = await this.http.post('onRemoveDopStudent', data).then((res) => {
        //console.log(res);
        swal(res.data.message, '', 'success');
        this.$store.commit('setUser', res.data.user);
        this.clearDops();
        this.checkActiveStudents();
      });
    },
    daysToFinish() {
      let to = moment(this.to_date, 'D-M-Y H:mm');
      let now = new moment();
      //let dim = moment().daysInMonth();
      let diff = to.diff(now, 'days');
      return diff;
    },
    addDopStudent(qnt) {
      // 1. Определяем сколько дней до конца оплаченного периода
      let days_left = this.daysToFinish();
      let daysInMonth = moment().daysInMonth();
      let pricePerStudent = this.prices.per_student;
      let day_price = pricePerStudent / daysInMonth;
      let final_price = Math.round(((days_left * day_price) * qnt));
      this.type = 'add';
      this.dop_price = final_price;
      this.need_qnt = qnt;
      //console.log('Нужно доплатить', final_price);
      let message = `До конца оплаченного периода осталось <strong>${days_left}</strong> дня. Для того чтобы добавить дополнительных учеников в количестве <strong>${qnt}</strong> чел. вам необходимо доплатить <strong>${final_price} руб.</strong> Необходимая сумма спишется с вашего баланса. Убедитесь что у вас достаточно средств для этой операции.`;
      // Выводить эту надпись при изменении количества учеников. А когда нажмут, просто выполнять.
      //console.log(message);
      this.dop_message = message;
    },
    removeDopStudents(qnt) {
      let message;
      let max = this.o_params.addition_students + this.prices.students_in_subscribe;
      if(this.active_students > (max - qnt)){
        let razn = (this.active_students + qnt) - max;
        this.type = '';
        message = `Вы хотите убрать ${qnt} дополнительных учеников. Для этого Вам необходимо удалить или заморозить ${ razn } учеников`;
      } else {
        message = `Убрать ${qnt} дополнительных учеников?`;
        this.type = 'remove'
      }

      this.dop_message = message;
      this.need_qnt = qnt;
    },
    changeStudentsQnt() {
      let dop_qnt = this.dop_qnt;
      let params = this.o_params;
      let addition_students = params.addition_students;
      if (addition_students > dop_qnt) {
        let qnt = addition_students - dop_qnt;
        //console.log('Убавляем', qnt);
        this.removeDopStudents(qnt);
      } else if (addition_students < dop_qnt) {
        let qnt = dop_qnt - addition_students;
        //console.log('Добавляем', qnt);
        this.addDopStudent(qnt);
      } else {
        //console.log('Ни хера не делаем',);
        this.clearDops();
      }

    },

  },
  mounted() {
    this.setItem();
    this.checkActiveStudents();
    $('.datepicker-here').datepicker({ autoClose: true });
  }
}
</script>